import React, { useEffect, useRef } from 'react';
import { IoLocationOutline } from 'react-icons/io5';

const StaticKakaoMapContainer = ({ 
    latitude, 
    longitude, 
    level = 3, 
    className = "w-full h-full",
    fallbackClassName = "w-full h-full bg-gray-200 flex items-center justify-center"
}) => {
    const staticMapRef = useRef(null);

    useEffect(() => {
        if (latitude && longitude && window.kakao && window.kakao.maps && staticMapRef.current) {
            const staticMapOption = {
                center: new window.kakao.maps.LatLng(latitude, longitude),
                level: level,
                marker: {
                    position: new window.kakao.maps.LatLng(latitude, longitude)
                }
            };

            try {
                // 기존 지도가 있다면 제거
                staticMapRef.current.innerHTML = '';
                new window.kakao.maps.StaticMap(staticMapRef.current, staticMapOption);
                
                // 지도 클릭 이벤트 방지
                const mapElement = staticMapRef.current.querySelector('a');
                if (mapElement) {
                    mapElement.style.pointerEvents = 'none';
                }
            } catch (error) {
                console.error('Static map creation failed:', error);
                // 에러 시 fallback UI 표시
                if (staticMapRef.current) {
                    staticMapRef.current.innerHTML = `
                        <div class="${fallbackClassName}">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" class="text-gray-400">
                                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                            </svg>
                        </div>
                    `;
                }
            }
        }
    }, [latitude, longitude, level]);

    // 좌표가 없는 경우 fallback UI
    if (!latitude || !longitude) {
        return (
            <div className={fallbackClassName}>
                <IoLocationOutline size={32} className="text-gray-400" />
            </div>
        );
    }

    return (
        <div 
            ref={staticMapRef} 
            className={className}
            style={{ minHeight: '200px' }}
            onClick={(e) => e.preventDefault()} // 컨테이너 레벨에서도 클릭 이벤트 방지
        />
    );
};

export default StaticKakaoMapContainer; 